module.exports = __webpack_public_path__ + "static/img/pay_qrpay_wechatpay@3x.ac6d945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay_wechatpay@3x.png
// module id = AZTi
// module chunks = 1